@if (device) {
    <div class="inner-modal-content">
        <div class="columns is-multiline is-mobile is-side-marginless">
            <div class="column is-7 is-full has-text-left">
                <p class="headline is-size-3 has-text-left">Détail du prix</p>
            </div>
        </div>
        <div class="column"></div>
        @if (discountWithPlan || instantDiscount) {
            <div class="columns is-multiline is-mobile is-side-marginless">
                <div class="column is-7 is-full has-text-left">
                    <p class="text is-level-2 is-marginless">Prix seul</p>
                </div>
                <div class="column is-5 is-full has-text-right-desktop has-text-right-mobile main">
                    <trg-price
                        size-6
                        [isInlined]="true"
                        [price]="device.prix.initial"
                        [isWithoutTax]="isWithoutTax"
                        class="modal-price-price"
                    ></trg-price>
                </div>
            </div>
            @if (plan && discountWithPlan) {
                <div class="columns is-multiline is-mobile is-side-marginless">
                    <div class="column is-8 is-full has-text-left">
                        <p class="text is-marginless is-level-2">Remise avec un forfait {{ plan.dataEnvelope }}</p>
                        <p class="text is-level-3 is-marginless">Engagement {{ planDuration }} mois</p>
                    </div>
                    <div class="column is-4 is-full has-text-right-desktop has-text-right-mobile main">
                        -
                        <trg-price
                            size-6
                            [isInlined]="true"
                            [price]="discountWithPlan"
                            [isWithoutTax]="isWithoutTax"
                            class="modal-price-price"
                        ></trg-price>
                    </div>
                </div>
            }
            @if (instantDiscount) {
                <div class="columns is-multiline is-mobile is-side-marginless">
                    <div class="column is-7 is-full has-text-left">
                        <p class="text is-marginless is-level-2">Remise immédiate</p>
                    </div>
                    <div class="column is-5 is-full has-text-right-desktop has-text-right-mobile main">
                        -
                        <trg-price
                            size-6
                            [isInlined]="true"
                            [price]="instantDiscount"
                            [isWithoutTax]="isWithoutTax"
                            class="modal-price-price"
                        ></trg-price>
                    </div>
                </div>
            }
            <hr class="is-divider" />
        }
        <div class="columns is-multiline is-mobile is-side-marginless">
            <div class="column is-7 is-full has-text-left">
                <p class="text is-level-1 sub-title is-marginless">
                    <strong>Prix {{ deviceLabel }}</strong>
                </p>
            </div>
            <div class="column is-5 is-full has-text-right-desktop has-text-right-mobile main">
                <div class="subtitle has-text-tertiary is-inline-flex is-vcentered">
                    =&nbsp;
                    <trg-price
                        size-6
                        [isInlined]="true"
                        [price]="device.prix?.final"
                        [isWithoutTax]="isWithoutTax"
                    ></trg-price>
                </div>
            </div>
        </div>
        <div class="columns is-side-marginless">
            <div class="column"></div>
        </div>
        @if (funding.montantMensualite > 0) {
            <div class="columns is-multiline is-mobile is-side-marginless">
                <div class="column is-7 is-full has-text-left">
                    <p class="text is-level-2 is-marginless">À régler aujourd'hui</p>
                </div>
                @if (funding) {
                    <div class="column is-5 is-full has-text-right-desktop has-text-right-mobile main">
                        <trg-price
                            size-6
                            [isInlined]="true"
                            [price]="funding.apportInitial"
                            [isWithoutTax]="isWithoutTax"
                            class="modal-price-price"
                        ></trg-price>
                    </div>
                }
            </div>
        }
        @if (odr && funding.type === 'EDP') {
            <ng-template [ngTemplateOutlet]="odrBlock"></ng-template>
        }
        @if (funding.montantMensualite > 0) {
            <div class="columns is-multiline is-mobile is-side-marginless">
                <div class="column is-6 is-full has-text-left">
                    <p class="text is-marginless is-level-2">Puis à payer par mois</p>
                    <p class="text is-level-3 is-marginless">
                        {{
                            funding.type === 'EDP'
                                ? 'Facilité sur ' + funding.nbrEcheances + ' mois'
                                : 'Financement sur ' + funding.nbrEcheances + ' mois*'
                        }}
                        {{ funding.type === 'EDP' && isWithoutTax ? ' (non soumis à la TVA)' : '' }}
                    </p>
                </div>
                <div class="column is-6 is-full has-text-right-desktop has-text-right-mobile main">
                    +
                    <trg-price
                        size-6
                        [isInlined]="true"
                        [hasPeriod]="true"
                        [price]="funding.montantMensualite"
                        class="modal-price-price"
                    ></trg-price>
                </div>
            </div>
        }
        @if (odr && funding.type !== 'EDP') {
            <ng-template [ngTemplateOutlet]="odrBlock"></ng-template>
        }
        @if (odr) {
            <hr class="is-divider" />
            <div class="columns is-mobile filter-by-wrap is-side-marginless">
                <div class="column is-8 is-paddingless is-full has-text-left">
                    <p class="text is-level-1 sub-title is-marginless"><strong>Prix après remboursement</strong></p>
                </div>
                <div class="column is-4 is-paddingless is-full has-text-right main">
                    <div class="subtitle has-text-tertiary is-inline-flex is-vcentered">
                        =&nbsp;
                        <trg-price
                            size-6
                            [isInlined]="true"
                            [price]="priceWithOdr"
                            [isWithoutTax]="isWithoutTax"
                        ></trg-price>
                    </div>
                </div>
            </div>
        }
        @if (funding.type.includes('YOUNITED')) {
            <div class="is-loaded subtable has-text-left has-background-grey-lighter column card is-shadowless">
                <p class="text is-level-3 is-flex is-marginless">
                    *Financement
                    <img src="/portailvente/product-wall/logo-younited.svg" alt="Younited" width="70" />
                </p>
                <p class="text is-level-3 is-marginless">
                    <span>Intérêts : {{ funding.montantInteret }}€</span>
                    <span>/ Taux annuel effectif global (TAEG) fixe : {{ funding.tAEG }}%</span>
                    @if (funding?.tauxDebiteurFixe >= 0) {
                        <span>/ Taux débiteur fixe : {{ funding.tauxDebiteurFixe }}%</span>
                    }
                </p>
                <p class="text is-level-3">
                    Un crédit vous engage et doit être remboursé. Vérifiez vos capacités de remboursement avant de vous
                    engager.
                </p>
            </div>
        }
        <ng-template #odrBlock>
            <div class="columns is-multiline is-mobile is-side-marginless">
                <div class="column is-9 is-full has-text-left">
                    <p class="text is-level-2 is-inline">Remboursement après achat</p>
                    <div class="popover is-inline">
                        <span class="icon popover-modal">
                            <i class="tri-infos-circle" aria-hidden="true"></i>
                        </span>
                        <div class="popover-content">
                            Le coupon et les instructions vous seront envoyés par mail après achat.
                        </div>
                    </div>
                </div>
                <div class="column is-3 is-full has-text-right-desktop has-text-right-mobile main">
                    -
                    <trg-price
                        size-6
                        [isInlined]="true"
                        [price]="odr.reduction"
                        [isWithoutTax]="isWithoutTax"
                        class="modal-price-price"
                    ></trg-price>
                </div>
            </div>
        </ng-template>
    </div>
}
